<template>
  <div class="coming-soon text-h4">
    <h1>{{ $t('coming_soon.soraremega_will_come_back_soon') }}</h1>
    <p class="mt-4">{{ $t('coming_soon.enter_email') }}</p>
    <v-text-field
      v-model="email"
      label="Email"
      variant="outlined"
      density="compact"
      hide-details
      class="email-field mt-6"
    />
    <VBtn
      color="primary"
      :loading="isLoading"
      :disabled="isDisabled"
      @click="submitEmail"
    >
      {{ $t('coming_soon.submit') }}
    </VBtn>

    <div class="social">
      <a
        :href="$consts.TWITTER_URL"
        target="_blank"
      >
        <font-awesome-icon
          :icon="['fab', 'x-twitter']"
          size="lg"
        />
      </a>
    </div>
    <snackbar
      v-model="displaySnackbar"
      :text="$t('coming_soon.success_message')"
      :color="$consts.SNACKBAR.COLOR.SUCCESS"
    />
  </div>
</template>

<script>
import N8nService from '@/services/n8n.service';
import Snackbar from "@/components/Snackbar.vue";

export default {
  name: 'ComingSoon',
  components: {Snackbar},
  data() {
    return {
      email: '',
      isLoading: false,
      isDisabled: false,
      displaySnackbar: false,
    };
  },
  methods: {
    submitEmail() {
      this.isLoading = true;
      N8nService.postListMonkWebhook(this.email)
        .finally(() => {
          this.isLoading = false;
          this.isDisabled = true;
          this.displaySnackbar = true;
        });
    },
  },
};
</script>

<style scoped>
.coming-soon {
  text-align: center;
}

h1 {
  line-height: 70px;
}

.email-field {
  margin: 0 auto;
  max-width: 300px;
}
.social {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 40px;
}
</style>
